import { render, staticRenderFns } from "./NtfItem.vue?vue&type=template&id=a08d51f4&scoped=true"
import script from "./NtfItem.vue?vue&type=script&lang=js"
export * from "./NtfItem.vue?vue&type=script&lang=js"
import style0 from "./NtfItem.vue?vue&type=style&index=0&id=a08d51f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08d51f4",
  null
  
)

export default component.exports